module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_1_GA-1f4f2682c26ee37e49adc6ecb49a81e2.svg";